import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'aa-view-ch3',
    templateUrl: './view-ch3.component.html',
    styleUrls: [
        './view-ch3.component.scss'
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ViewCh3Component {
}
